import { render, staticRenderFns } from "./InnerPageTemplate.vue?vue&type=template&id=58aaf84c&scoped=true&"
import script from "./InnerPageTemplate.vue?vue&type=script&lang=ts&"
export * from "./InnerPageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./InnerPageTemplate.vue?vue&type=style&index=0&id=58aaf84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aaf84c",
  null
  
)

export default component.exports